// Shared shaping of the time-off request payloads so Schedule and Timesheets
// build identical request bodies. Status is intentionally omitted - the server
// decides it from the requester's permissions.

export function buildTimeOffCreatePayload(form, fallbackEmployeeId) {
  return {
    employee_id: form.employee_id || fallbackEmployeeId,
    time_off_type_id: form.timeOffTypeId,
    start_date: form.startDate,
    end_date: form.endDate,
    reason: form.reason,
    start_half_day: !!form.startHalfDay,
    end_half_day: !!form.endHalfDay,
  };
}

export function buildTimeOffUpdatePayload(form) {
  return {
    time_off_type_id: form.timeOffTypeId,
    start_date: form.startDate,
    end_date: form.endDate,
    reason: form.reason,
    start_half_day: !!form.startHalfDay,
    end_half_day: !!form.endHalfDay,
  };
}
